export const priceList = {
  website: {
    builder: {
      no: 0,
      wordpress: 5_000_000,
      custom: 10_000_000,
    },
    uniquePages: {
      one: 500_000,
      twoToNine: 1_000_000,
      tenToNineteen: 3_000_000,
      twentyPlus: 5_000_000,
    },
    designPreference: {
      no: 0,
      simple: 2_000_000,
      custom: 5_000_000,
    },
    mobileApps: {
      no: 0,
      android: 8_000_000,
      ios: 10_000_000,
      both: 15_000_000,
    },
    languages: {
      onlyBahasa: 0,
      onlyEnglish: 500_000,
      bahasaEnglish: 1_000_000,
      custom: 2_000_000,
    },
    features: {
      contentEditor: 1_000_000,
      hosting: 500_000,
      domain: 200_000,
      webAd: 1_500_000,
      seo: 2_000_000,
      businessEmail: 500_000,
      ecommerce: 3_000_000,
    },
    maintenance: 2_400_000,
  },
  design: {
    logo: {
      no: 0,
      basic: 1_500_000,
      custom: 3_000_000,
    },
    logoFeatures: {
      businessCard: 500_000,
      stationeries: 1_000_000,
      idCard: 500_000,
      customMockups: 1_500_000,
    },
    packaging: {
      no: 0,
      simple: 1_000_000,
      advanced: 2_500_000,
    },
    photography: {
      no: 0,
      one: 300_000,
      twoToNine: 800_000,
      tenToNineteen: 2_000_000,
      twentyPlus: 3_500_000,
    },
    catalog: {
      no: 0,
      one: 300_000,
      twoToNine: 800_000,
      tenToNineteen: 2_000_000,
      twentyPlus: 3_500_000,
    },
    marketplace: {
      no: 0,
      one: 200_000,
      twoToNine: 600_000,
      tenToNineteen: 1_800_000,
      twentyPlus: 3_000_000,
    },
    socialMedia: {
      no: 0,
      fixed: {
        no: 0,
        oneToThree: 500_000,
        fourToSix: 1_500_000,
        sevenToNine: 2_500_000,
        tenPlus: 4_000_000,
      },
      regularly: {
        monthly: {
          no: 0,
          oneToThree: 800_000,
          fourToSix: 2_000_000,
          sevenToNine: 3_500_000,
          tenPlus: 5_000_000,
        },
        weekly: {
          no: 0,
          oneToThree: 1_000_000,
          fourToSix: 2_500_000,
        },
      },
    },
    mascot2d: {
      no: 0,
      one: 1_000_000,
      twoToNine: 2_500_000,
      tenToNineteen: 6_000_000,
      twentyPlus: 10_000_000,
    },
    mascot3d: {
      no: 0,
      one: 2_000_000,
      twoToNine: 5_000_000,
      tenToNineteen: 12_000_000,
      twentyPlus: 20_000_000,
    },
  },
  video: {
    shortVideo: {
      no: 0,
      fixed: {
        no: 0,
        oneToThree: 1_000_000,
        fourToSix: 3_000_000,
        sevenToNine: 5_000_000,
        tenPlus: 8_000_000,
      },
      regularly: {
        monthly: {
          no: 0,
          oneToThree: 1_500_000,
          fourToSix: 4_000_000,
          sevenToNine: 7000_000,
          tenPlus: 10_000_000,
        },
        weekly: {
          no: 0,
          oneToThree: 2_000_000,
          fourToSix: 5_000_000,
          sevenToNine: 9000_000,
          tenPlus: 13_000_000,
        },
      },
    },
    liveStreaming: {
      no: 0,
      fixed: {
        no: 0,
        oneToThree: 1_000_000,
        fourToSix: 3_000_000,
        sevenToNine: 5_000_000,
        tenPlus: 8_000_000,
      },
      regularly: {
        monthly: {
          no: 0,
          oneToThree: 1_500_000,
          fourToSix: 4_000_000,
          sevenToNine: 7_000_000,
          tenPlus: 10_000_000,
        },
        weekly: {
          no: 0,
          oneToThree: 2_000_000,
          fourToSix: 5_000_000,
          sevenToNine: 9_000_000,
          tenPlus: 13_000_000,
        },
      },
    },
  },
}

